import { render, staticRenderFns } from "./BAPenolakan.vue?vue&type=template&id=2e56f1f2&"
import script from "./BAPenolakan.vue?vue&type=script&lang=js&"
export * from "./BAPenolakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports